import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#2A3D19] py-8 px-20 md:px-8 relative">
      <Link to="#header">
        <img
          src="https://res.cloudinary.com/druryt8ny/image/upload/v1700518877/x5okdpgqcswd8gnmo4fk.png"
          alt="triangle"
          className="absolute bottom-8 right-4"
        />
      </Link>
      <div className="flex flex-col md:flex-row md:justify-evenly md:gap-6 mt-8">
        <div className="flex gap-4 justify-between md:justify-evenly md:w-[40%]">
          <div className="text-white flex flex-col gap-2">
            <h1 className="font-bold text-2xl mb-4">Thrive</h1>
            <Link to="/faq" className="font-semibold">
              FAQ
            </Link>
            <Link to="/moodtrack" className="font-semibold">
              Mood Track
            </Link>
            <Link to="/helpandsupport" className="font-semibold">
              Help & Support
            </Link>
          </div>
          <div className="text-white flex flex-col gap-2">
            <h1 className="font-bold text-2xl mb-4">Social</h1>
            <Link to="" className="font-semibold">
              Facebook
            </Link>
            <Link to="" className="font-semibold">
              Instagram
            </Link>
            <Link to="" className="font-semibold">
              Twitter
            </Link>
          </div>
        </div>
        <div className="text-white flex flex-col gap-2 mt-12 md:mt-0">
          <h1 className="font-bold text-2xl mb-4">Services</h1>
          <Link to="/mainresources" className="font-semibold">
            Resources
          </Link>
          <Link to="/relaxation1" className="font-semibold">
            Relaxation
          </Link>
          <Link to="/therapy" className="font-semibold">
            Therapy
          </Link>
        </div>
        <div className="flex flex-col md:flex-row md:gap-0 gap-2 justify-stretch mt-6 self-end">
          <input
            type="email"
            placeholder="Email Address"
            className="px-2 py-1 md:py-2 rounded-sm md:rounded-tr-none md:rounded-br-none block w-80 focus:outline-none"
          />
          <button className="block bg-white md:bg-green-400 md:rounded-tl-none md:rounded-bl-none px-2 py-1 rounded-sm w-80 md:w-40 text-semibold text-[#2A3D19] font-bold hover:bg-green-300">
            Subscribe
          </button>
        </div>
      </div>
      <p className="text-center text-white mt-8 font-semibold">
        {`copyright© ${new Date().getFullYear()} thrive.techtribe all right
  reserved`}
      </p>
    </footer>
  );
};

export default Footer;
